import * as React from 'react'

import { Typography } from '@mui/material'
import { useRef } from 'react'

const MyViewEditorHtml = (props: {
  notes: any
  additionalStyles?: any
  maxImageWidth?: number
}) => {
  const htmlDomRef = useRef<any>(null)
  const domElement = htmlDomRef?.current

  React.useEffect(() => {
    console.log('About to call resize iframe')
    reduceSizeOfMediaIframes()
    setTimeout(() => {
      // add artificial delay till page has loaded
      reduceSizeOfMediaIframes()
    }, 1500)
  }, [props.notes, props.maxImageWidth])

  const reduceSizeOfMediaIframes = () => {
    console.log('resizing ...', { domElement })
    if (!domElement) {
      return
    }
    const iframeList = domElement?.getElementsByTagName('iframe')
    for (let i = 0; i < iframeList.length; i++) {
      const iframeSrc = iframeList[i].getAttribute('src')
      if (iframeSrc && iframeSrc.indexOf('youtube.com') !== -1) {
        iframeList[i].setAttribute('src', `${iframeSrc}?rel=0`)

        if (outerWidth < 700) {
          // iframeList[i].width = (outerWidth - 80).toString();
          iframeList[i].style.width = '90vw'
          iframeList[i].style.maxWidth = '100%'
          // iframeList[i].height = (0.56 * (outerWidth - 40)).toString();
        }
      }
    }

    //  images
    const imagesList = domElement?.getElementsByTagName('img')

    for (let i = 0; i < imagesList.length; i++) {
      const imgSrc = imagesList[i].getAttribute('src')
      // let setWidth = Math.min(imagesList[i].width, 700);
      const setWidth = imagesList[i].width

      if (imgSrc && setWidth > outerWidth) {
        imagesList[i].style.width = '90vw'
        imagesList[i].style.maxWidth = '100%'
        imagesList[i].style.height = 'auto'
      }

      if (imgSrc && props.maxImageWidth && setWidth > props.maxImageWidth) {
        imagesList[i].style.width = '90vw'
        imagesList[i].style.maxWidth = '100%'
        imagesList[i].style.height = 'auto'
      }
    }
  }

  return (
    <div ref={htmlDomRef}>
      <Typography
        style={{
          // userSelect: "none",
          overflowX: 'auto',
          fontFamily: 'Lato, Poppins, Reem Kufi',
          ...props.additionalStyles,
        }}
        dangerouslySetInnerHTML={{ __html: props.notes }}
        component="div"
        variant="body2"
      />
    </div>
  )
}

export default MyViewEditorHtml
